import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFindAllProjectsQuery } from "../../../../features/projectApi";
import { keycloak } from "../../../lib/keycloak";
import { useAppDispatch } from "../../../lib/redux/hooks";
import { Layout } from "../../../ui/layout";
import Button from "../../../ui/molecules/button";
import { Spinner } from "../../../ui/molecules/spinner";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { NotFound } from "../../../ui/organisms/notFound";
import { setCreateFromProject } from "../../users/slice";
import { EditProjectPage, FindAllProjectsFilters } from "../dto";
import { setEditProjectPage } from "../slice";
import { ProjectsFilters } from "./filters";
import { ProjectsList } from "./list";

export function Projects() {
    const dispatch = useAppDispatch()
    const navigation = useNavigate()

    const [filters, setFilters] = useState<FindAllProjectsFilters>({
        commercial: [],
        name: "",
        sector: [],
        startDate: [],
        category: [],
        state: [],
        teamLeaderId: undefined,
        order: true,
        sort: "name",
        itemsPerPage: 50,
        page: 0,
    })
    const { data: projectsResponse, isLoading } = useFindAllProjectsQuery(filters)

    const projects = projectsResponse?.projects
    const commercials = projectsResponse?.commercials
    const teamLeaders = projectsResponse?.teamLeaders

    useEffect(() => {
        dispatch(setEditProjectPage(EditProjectPage.LIST))
    }, [])

    if (isLoading) {
        return <div className="flex items-center justify-center h-screen w-full"><Spinner /></div>
    }

    return (
        <Layout
            menuItem={MenuItems.PROJECTS}
            breadcrumbItems={['Progetti']}
            headerLabel="Progetti"
            headerChildren={
                (
                    !keycloak.hasRealmRole("commercial") && !keycloak.hasRealmRole('customer') && !keycloak.hasRealmRole('collaborator') ?
                        <div className="flex items-center h-[100%] w-[100%] justify-end">
                            <Button
                                size={"sm"}
                                iconPosition={"off"}
                                label="Nuovo progetto"
                                variant={"solid"}
                                color={"blue"}
                                onClick={() => {
                                    dispatch(setCreateFromProject(undefined))
                                    navigation('/new-project')
                                }}
                            />
                        </div> : <></>
                )
            }
        >
            <div className="p-4 h-full max-h-full">
                <div className="flex h-full flex-col bg-white rounded-2xl shadow-sm">
                    <ProjectsFilters
                        filters={filters}
                        setFilters={filt => setFilters({ ...filters, ...filt, page: 0 })}
                    />
                    {

                        projects?.data.length === 0 || projects?.data === null ?
                            <div style={{ height: 'calc(100% - 64px - 60px)' }}>
                                <NotFound />
                            </div> :
                            <ProjectsList
                                teamLeaders={teamLeaders ?? []}
                                commercials={commercials ?? []}
                                projects={projects!}
                                filters={filters}
                                setFilters={arg => setFilters({ ...filters, ...arg })}
                            />
                    }
                </div>
            </div>
        </Layout>
    )
}